// XXX: 디자인 라이브러리가 생기면서 컨텍스트별로 static asset을 가져올일은 많이 없어지지 않았을까 하여 그냥 파일타입으로 분류해보았다.
import {getEnv} from '../../env/env';

export enum StaticAssetType {
  Image = 'images',
  Background = 'backgrounds',
  Js = 'js',
  Font = 'font',
  Sample = 'sample',
}

export function getStaticAssetUrl(
  assetName: string,
  assetType: StaticAssetType
) {
  return `${getEnv()?.assetPrefix || ''}/public/${assetType}/${assetName}`;
}
